import React from 'react';
import media from "../../../../resources/Archway_Token_Red2.png"

const TokenSVG = () => {
    return (
        <div className="mx-2 h w-4">
           <img src={media} alt={"archway"}/>
        </div>

    );
};

export default TokenSVG;